import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Taiga UI imports
import {
  TuiButton,
  TuiDataList,
  TuiError,
  TuiIcon,
  TuiLabel,
  TuiLoader,
  TuiNotification,
} from '@taiga-ui/core';
import { TuiCheckbox, TuiDataListWrapper } from '@taiga-ui/kit';
import {
  TuiInputModule,
  TuiSelectModule,
  TuiTextareaModule,
} from '@taiga-ui/legacy';

import { ConfigCompanyComponent } from './config-company/config-company.component';
import { SapQueryComponent } from './sap-query/sap-query.component';
import { StaffRoutingModule } from './staff-routing.module';

@NgModule({
  declarations: [SapQueryComponent, ConfigCompanyComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    StaffRoutingModule,
    // Taiga UI modules
    TuiButton,
    TuiCheckbox,
    TuiIcon,
    TuiLabel,
    TuiLoader,
    TuiNotification,
    TuiInputModule,
    TuiSelectModule,
    TuiTextareaModule,
    ...TuiDataList,
    ...TuiDataListWrapper,
    TuiError,
  ],
})
export class StaffModule {}
